import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Interceptor: attach the "acting as tenant" header for super-admin impersonation
api.interceptors.request.use((config) => {
  try {
    const t = localStorage.getItem("act_as_tenant");
    if (t) config.headers = { ...(config.headers || {}), "X-Act-As-Tenant": t };
  } catch { /* ignore */ }
  return config;
});

export function actAsTenant(tenantId) {
  if (tenantId) localStorage.setItem("act_as_tenant", tenantId);
  else localStorage.removeItem("act_as_tenant");
}
export function currentImpersonation() {
  try { return localStorage.getItem("act_as_tenant") || null; } catch { return null; }
}

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
